import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToTasks() {
  return <Redirect to="/db/tasks&notes/tasks" />;
}
